export const getObjValue = (o, p) => p.split('.').reduce((a, v) => (a && a[v]) || '', o);
